// extracted by mini-css-extract-plugin
export default {"content":"Permits_content__HmrJb","tableRef":"Permits_tableRef__yITVo"};